"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProjectPermission = void 0;
var collectionsRef_1 = require("common/db/collectionsRef");
var app_1 = __importDefault(require("firebase/app"));
var firestore_1 = require("react-firebase-hooks/firestore");
var useProjectPermission = function (projectId, projectPermissions) {
    var userId = app_1.default.auth().currentUser.uid;
    var _a = (0, firestore_1.useCollection)(collectionsRef_1.projectsRolesRef.where('projectId', '==', projectId).where('userId', '==', userId)), userProjectRolesSnapshot = _a[0], lodingUserProjectRoles = _a[1];
    if (lodingUserProjectRoles) {
        return null;
    }
    var userRoles = userProjectRolesSnapshot === null || userProjectRolesSnapshot === void 0 ? void 0 : userProjectRolesSnapshot.docs.map(function (doc) {
        var _a;
        return (_a = doc.data()) === null || _a === void 0 ? void 0 : _a.role.toLowerCase();
    });
    return projectPermissions.some(function (r) { return userRoles.includes(r.toLowerCase()); });
};
exports.useProjectPermission = useProjectPermission;
